/* eslint-disabled */

import Printable from "@/entity/Printable";
import Item from "@/entity/Item";
import ItemType from "@/entity/ItemType";
import ItemProperty from "@/entity/ItemProperty";
import Property from "@/entity/Property";

export default class ItemTypeExtend {

    expand: boolean
    entity: any = null
    workflows: any[] = []

    constructor(object?: any) {
        this.expand = true
        if (object) {
            this.entity = object.entity
            this.workflows = object.workflows
        }
    }

    postConstruct() {
    }

    useWorkflow(workflow: any) {
        const self: ItemType = this as any
        return self.workflows.findIndex((w: any) => {
            return w.code === workflow.code
        }) !== -1
    }

    // addCoverageProperty() {
    //     const self: ItemType = this as any
    //     if (self.className === 'Asset') {
    //         const prop = new ItemProperty()
    //         prop.type
    //     }
    // }

    getPropertyTypeByUuid(uuid: string) {
        const self: ItemType = this as any
        for (let prop of self.properties) {
            // console.log(prop.name + ' => ' + prop.uuid + ' ' + uuid)
            if (prop.uuid === uuid) {
                return prop
            }
        }
    }

    getPropertyTypeByCode(code: string) {
        const self: ItemType = this as any
        for (let prop of self.properties) {
            if (prop.code === code) {
                return prop
            }
        }
    }

    getPropertyByUuid(uuid: string) {
        let value: any = null;
        const self: ItemType = this as any;
        self.properties.forEach((p: ItemProperty) => {
            if (p.uuid === uuid) {
                value = p;
            }
        });
        return value;
    }


    generateItem() {
        const self: ItemType = this as any;
        const item = new Item({name: self.name, model: self})
        self.properties.forEach((p: ItemProperty) => {
            const prop = new Property()
            prop.name = p.name
            prop.model = p
            item.properties.push(prop)
        })

        return item
    }
}
